/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

/**
 * Create the new instance of class.
 */
const createCommands = <CommandType>(type: { new (): CommandType }): CommandType => {
    return new type();
};

export default createCommands;
